//npm packages
import React, { memo } from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

//redux actions
import { modelForm, modelList } from '../../redux/actions';

//elements starts with capital letter
import { GridBase } from '../../components';

//helper files
import strings from '../../globalization';
import consts from '../../consts';

const Model = memo(props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const onDelete = async ({ row: { _id } }) => {
    Swal.fire({
      title: strings.DeleteWarning,
      text: strings.DeleteText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: strings.DeleteConfirmButton
    }).then(result => {
      if (result.value) {
        dispatch(modelForm({ action: 'delete', _id }));
        history.push({ pathname: `/modelList` });
      }
    });
  };

  const deleteRenderer = data => {
    const isComingFromSeeder = data.row.IsComingFromSeeder;
    if (isComingFromSeeder) {
      return <div></div>;
    } else {
      return (
        <div>
          <Button
            size="sm"
            title={strings.Delete}
            className="deleteBtn"
            type="button"
            color="danger"
            onClick={() => onDelete(data)}
          >
            <FontAwesomeIcon icon={faTrash} /> {strings.Delete}
          </Button>
        </div>
      );
    }
  };

  const columns = [
    { key: 'ModelName', name: strings.ModelName, width: 180, type: 'text' },
    {
      key: 'EquipmentFamily',
      name: strings.EquipmentFamily,
      width: 250,
      mode: 'remote',
      store: 'EquipmentFamily',
      valueProp: 'DisplayValue',
      displayValue: 'Name'
    },
    {
      key: 'ConnectivityType',
      name: strings.ConnectivityType,
      width: 250,
      mode: 'remote',
      store: 'ConnectivityType',
      valueProp: '_id',
      displayValue: 'DisplayValue'
    },
    {
      key: 'DeviceType',
      name: strings.DeviceType,
      width: 150,
      mode: 'remote',
      store: 'DeviceType',
      valueProp: '_id',
      displayValue: 'DisplayValue'
    },
    {
      key: 'DataType',
      name: strings.DataType,
      width: 100,
      mode: 'remote',
      store: 'DataType',
      valueProp: '_id',
      displayValue: 'DisplayValue'
    },
    {
      key: 'Hulu',
      name: strings.Hulu,
      type: 'bool',
      width: 90
    },
    {
      key: 'IsActive',
      name: strings.Active,
      type: 'bool',
      width: 90
    },
    {
      key: 'Actions',
      type: 'action',
      name: strings.Delete,
      getRowMetaData: row => row,
      formatter: deleteRenderer,
      width: 150
    }
  ];

  return (
    <GridBase
      {...props}
      key={Math.random()}
      columns={columns}
      title={strings.EquipmentModel}
      dataProperty="modelListData"
      parentRoute="modelList"
      action={modelList}
      comboType={[
        'ConnectivityType',
        'EquipmentFamily',
        'CycleTime',
        'DeviceType',
        'DataType'
      ]}
      sortColumn={'ModelName'}
      gridSortDirection={'ASC'}
      loadPref={true}
      listId="EquipmentModel"
    />
  );
});

export default Model;
